import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface Props {
    children: ReactNode;
}

function isLoggedIn() {
    const token = localStorage.getItem("token");
    const expiresAt = localStorage.getItem("token_expires_at");

    if (!token) return false;

    if (!expiresAt) return true;

    const expiresAtMs = parseInt(expiresAt, 10);
    if (Number.isNaN(expiresAtMs)) return true;

    return Date.now() < expiresAtMs;
}

export default function ProtectedRoute({ children }: Props) {
    const location = useLocation();

    if (!isLoggedIn()) {
        return <Navigate to="/admin/login" replace state={{ from: location }} />;
    }

    return <>{children}</>;
}
